module.exports = __webpack_public_path__ + "img/full6-min.2db3cf19.png";